/** Case Files tab order (must match labels in wireJournal). */
export const JOURNAL_TAB_LABELS = [
  "Map",
  "Brief",
  "Timeline",
  "Clues",
  "Suspects",
  "Notes",
  "Accuse",
] as const;

export const JOURNAL_MAP_TAB_INDEX = 0;
export const JOURNAL_BRIEF_TAB_INDEX = 1;
export const JOURNAL_TIMELINE_TAB_INDEX = 2;
export const JOURNAL_CLUES_TAB_INDEX = 3;
export const JOURNAL_SUSPECTS_TAB_INDEX = 4;
export const JOURNAL_NOTES_TAB_INDEX = 5;
export const JOURNAL_ACCUSE_TAB_INDEX = 6;
